/**
 * @typedef {{product: Object, quantity: number, options: number[][]}} ProductItem
 */
(function () {
  const faqSection = document.querySelector('.common-product-faq');
  const registrationSection = document.querySelector('.product-registration');
  registrationSection.appendChild(faqSection);

  const tenantId = '000000';
  const project = 'DREAME-MALL';
  const appSecret = 'R$t6y7U!w8Q#2%kJL';
  const appId = 'H2m7Q8x3J4';
  const baseUrl = 'https://us-store.dreame.tech/dreame-store';
  const api = {
    warranty: "/api/v1/warranty/get-by-sn",
    warrantyList: "/api/v1/warranty/list-by-email",
    // 注册产品
    productRegister: "/api/v1/product-register/create",
    registeredproducts: "/api/v1/product-register/list-register-by-email",
    unregisteredproducts: "/api/v1/product-register/list-unregistered-by-email",
    // 销售渠道
    purchaseChannelList: "/api/v1/purchase-channel/list",
    // 根据sn码获取产品信息
    snProductList: "/api/v1/product/list-product-model-by-sn",
  }
  /**
   * @param {String} api 
   * @param {RequestInfo} info 
   */
  const request = async (api, data, info) => {
    const body = data;
    // 获取 body 的参数 json
    const bodyString = JSON.stringify(body);
    const timestamp = Date.now();
    const stringSignTemp = bodyString + timestamp + appSecret;
    const sign = CryptoJS.MD5(stringSignTemp).toString();

    return fetch(baseUrl + api, {
      ...{
        method: 'POST',
        body: bodyString,
        headers: {
          tenant_id: tenantId,
          project: project,
          'dreame-api-sign': sign,
          'dreame-api-app-id': appId,
          'dreame-api-timestamp': timestamp.toString(),
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
      ...info ?? {}
    }).then((res) => {
      return res.json();
    }).catch((err) => {
      console.error(err);
      throw err;
    });
  }

  window.productRegistrationVue = new Vue({
    el: '.product-registration',
    delimiters: ['${', '}'],
    data() {
      return {
        registeredProducts: [],
        registeredProductsLoading: true,
        unregisteredProducts: [],
        unregisteredProductsLoading: true,
        route: '/',
        routes: {
          default: '/',
          registerProduct: '/register-product',
          registerProductSuccess: '/register-product/success',
          registerProductFailed: '/register-product/failed',
        },
        registerForm: {
          sn: null,
          product_id: null,
          product_name: null,
          purchase_date: null,
          purchase_channel: null,
          purchase_channel_id: null,
          order_number: null,
          phone: null,
          phone_country_code: '+1',
          email: window.productRegistration.customer.email,
          shopfiy_user_id: window.productRegistration.customer.id,
          country_code: window.productRegistration.customer.countryCode,
        },
        // 选择的手机地区码索引
        selectedPhoneCountryIndex: 0,
        // 表单注册产品的失败码
        formErrorCode: null,
        // 显示 SN 选择产品浮窗
        showSnSkuSelector: false,
        // SN 选择产品的 Loading
        snSkuSelectorLoading: false,
        // Confirm 按钮的 loading 状态
        confirmLoading: false,
        // 渠道
        purchaseChannelList: null,
        // SN help 弹窗
        showSnDialog: false,
        // 展示手机号不合法的提示
        showIllegalPhoneNumber: false,
        // 是否已配网设备的表单
        isConfiguredProductForm: false,
        // SN查询的产品列表
        snProductList: [],
        // 国际区号
        dialingCodes: [],
        lostImage: 'https://cdn.shopify.com/s/files/1/0553/1320/3405/files/dreame-lost-image.jpg?v=1739431537',
        // 返回质保卡页面
        backToWarranty: false,
      }
    },
    watch: {
      route(value) {
        document.body.setAttribute('data-route', value);
        this.resizeFooter();
      },
      unregisteredProducts(value) {
        if (value.length > 0) {
          document.body.setAttribute('data-unregistered-products', '');
        } else {
          document.body.removeAttribute('data-unregistered-products');
        }
        this.resizeFooter();
      },
      selectedPhoneCountryIndex(value) {
        if (this.dialingCodes?.length > 0) {
          this.registerForm.phone_country_code = this.dialingCodes[value]?.dialing_code ?? '+52';
        }
      },
    },
    computed: {
      // SN 选择产品 SKU 名称
      selectSnProductName() {
        return this.snProductList?.find(v => v.id == this.registerForm.product_id)?.name ?? this.registerForm.product_name;
      },
      // SN 选择产品
      selectSnProduct() {
        return this.snProductList?.find(v => v.id == this.registerForm.product_id);
      },
      // 表单按钮在特定情况下开启关闭
      formConfirmButtonDisabled() {
        const invalidity = this.invalidity;
        if (this.showIllegalPhoneNumber) {
          return true;
        }
        if (this.isConfiguredProductForm) {
          return invalidity(this.registerForm.sn);
        } else {
          return invalidity(this.registerForm.sn) || invalidity(this.registerForm.product_id) || invalidity(this.registerForm.purchase_date)
            || invalidity(this.registerForm.purchase_channel_id) || invalidity(this.registerForm.order_number);
        }
      },
      // 匹配是否线下渠道
      isOfflineChannels() {
        return function (channelId) {
          const findChannel = this.purchaseChannelList.find((channel) => channel.id == channelId);
          return findChannel ? findChannel.no_check_order > 0 : false;
        }
      }
    },
    beforeMount() {
      // 滚动后收回日期选择 
      // window.addEventListener('scroll', () => {
      //   this.$refs.registerformDateInput?.blur();
      // }); 
      // 路由跳转
      const hash = window.location.hash.replace('#', '').split('?')[0];
      if (hash != null && hash != '') {
        const hashCamelCase = hash.replace(/-([a-z])/g, (match, p1) => p1.toUpperCase());;
        const route = this.routes[hashCamelCase];
        if (route) this.route = route;
      }
      if (this.getUrlQueryString(window.location.href, 'from') == 'warranty') {
        this.backToWarranty = true;
        this.route = this.routes.registerProduct;
      }
      document.body.setAttribute('data-route', this.route);
      // 初始化
      this.initData().catch((err) => {
        console.error(err);
        throw err;
      });;
    },
    created() {
      this.debouncedHandleInputSn = this.debounce(this.debouncedInputSn, 300);
      this.resizeFooter();
    },
    mounted() {
      this.$el.classList.remove('vue--loading');
    },
    methods: {
      getUrlQueryString(url, paramKey) {
        let urlObj = new URL(url);
        var reg = new RegExp("(^|&)" + paramKey + "=([^&]*)(&|$)", "i");
        var r = urlObj.search.substr(1).match(reg);
        if (r != null) {
          return (r[2]);
        }
        return null;
      },
      // 初始化数据
      async initData() {
        await this.getRegisteredproducts();
        await this.getUnregisteredproducts();
        await this.getDialingCodes();
        await this.getPurchaseChannelList();
      },
      invalidity(value) {
        return value == null || value == '';
      },
      /**
       * 初始化产品注册表单
       * @param {*} product 可选，已配网的产品
       */
      initProductRegisterForm(product) {
        if (product) {
          this.registerForm = {
            sn: product.sn,
            product_id: product.product_id,
            product_name: product.name,
            purchase_date: null,
            purchase_channel: null,
            purchase_channel_id: null,
            order_number: null,
            phone: null,
            phone_country_code: '+1',
            email: window.productRegistration.customer.email,
            shopfiy_user_id: window.productRegistration.customer.id,
            country_code: window.productRegistration.customer.countryCode,
          };
          this.isConfiguredProductForm = true;
        } else {
          this.registerForm = {
            sn: null,
            product_id: null,
            product_name: null,
            purchase_date: null,
            purchase_channel: null,
            purchase_channel_id: null,
            order_number: null,
            phone: null,
            phone_country_code: '+1',
            email: window.productRegistration.customer.email,
            shopfiy_user_id: window.productRegistration.customer.id,
            country_code: window.productRegistration.customer.countryCode,
          };
          this.isConfiguredProductForm = false;
        }
        this.selectedPhoneCountryIndex = 0;
        this.snProductList = [];
        this.formErrorCode = null;
      },
      async getRegisteredproducts() {
        this.registeredProductsLoading = true;
        return request(api.registeredproducts, {
          email: window.productRegistration.customer.email
        }).then((res) => {
          this.registeredProducts = res.data.list;
        }).finally(() => this.registeredProductsLoading = false);
      },
      async getUnregisteredproducts() {
        this.unregisteredProductsLoading = true;
        return request(api.unregisteredproducts, {
          email: window.productRegistration.customer.email,
          language: window.productRegistration.languageCode
        }).then((res) => {
          this.unregisteredProducts = res.data.list;
        }).finally(() => this.unregisteredProductsLoading = false);
      },
      async getPurchaseChannelList() {
        return request(api.purchaseChannelList, {
          country_code: window.productRegistration.customer.countryCode
        }).then((res) => {
          this.purchaseChannelList = res.data.list;
        }).catch((err) => {
          setTimeout(() => {
            if (this.purchaseChannelList == null) {
              console.error(err);
              this.getPurchaseChannelList();
            }
          }, 500);
        });
      },
      // 各个国家或地区的区号
      async getDialingCodes() {
        const data = await fetch(window.productRegistration.dialingCodesUrl);
        const object = await data.json();
        this.dialingCodes = object;
      },
      formatTimestamp(timestamp) {
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      },
      // 滚动到主视图
      scrollToContainer() {
        const contaner = document.querySelector('.product-registration__container');
        if (contaner && (window.scrollY + 40) > contaner.offsetTop) {
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }, 400);
        }
      },
      // Register Now
      handleClickRegisterNow(product) {
        this.initProductRegisterForm(product);
        this.route = this.routes.registerProduct;
        this.scrollToContainer();
      },
      // Add More Products
      handleClickAddMoreProducts() {
        this.initProductRegisterForm();
        this.route = this.routes.registerProduct;
        this.scrollToContainer();
      },
      handleClickSnQuestion() {
        this.showSnDialog = true;
      },
      handleInputSn(e) {
        const sn = e.target.value?.trim()?.toUpperCase() ?? '';
        this.registerForm.sn = sn;
        if (sn != '' && sn != null) {
          this.snProductList = [];
          this.snSkuSelectorLoading = true;
          this.registerForm.product_id = null;
          this.registerForm.product_name = null;
          this.debouncedHandleInputSn(e);
        } else {
          this.registerForm.product_id = null;
          this.registerForm.product_name = null;
          this.showSnSkuSelector = false;
          this.snSkuSelectorLoading = false;
        }
      },
      debouncedInputSn(e) {
        const sn = e.target.value.trim();
        if (sn == '' || sn == null) {
          // this.showSnSkuSelector = false;
          // this.snProductList = [];
          // this.registerForm.product_id = null;
          // this.registerForm.product_name = null;
          return;
        }
        // 根据 SN 匹配产品
        request(api.snProductList, {
          sn: sn,
        }).then((res) => {
          // 如果输入框值发生变化，忽略此次请求结果
          if (sn != e.target.value) {
            return;
          }
          if (!res.success || res.success == "false") {
            this.snProductList = [];
          } else {
            this.snProductList = res.data.List;
            // this.showSnSkuSelector = res.data.List.length > 1; 
            if (res.data.List.length > 1) {
              this.showSnSkuSelector = true;
            } else if (!this.showSnSkuSelector && res.data.List.length == 1 && res.data.List[0]?.id != null) {
              // 未显示sn产品选择弹窗，且sn产品列表只有一项时
              this.registerForm.product_id = res.data.List[0].id;
            }
          }
          this.snSkuSelectorLoading = false;
        }).catch((err) => {
          console.error(err);
          this.snSkuSelectorLoading = false;
        });
      },
      // 日期选择器的兼容
      handleClickDateInput(e) {
        const target = e.target;
        // if (target.showPicker) {
        //   target.showPicker();
        // }
        if (!target._flatpickr) {
          flatpickr(target, {
            maxDate: 'today',
            disableMobile: "true"
          }).open();
        }
      },
      // SN 选择了产品
      handleSelectSnProductSku(product) {
        this.registerForm.product_id = product.id;
        this.showSnSkuSelector = false;
      },
      // SN 点击产品名称，重新选择 SKU
      handleClickSnSkuProductName() {
        if (!this.snProductList?.length) {
          this.snSkuSelectorLoading = true;
          request(api.snProductList, {
            sn: this.registerForm.sn,
          }).then((res) => {
            if (!res.success || res.success == "false") {
              this.snProductList = [];
              return;
            }
            this.snProductList = res.data.List;
          }).catch((err) => {
            console.error(err);
          }).finally(() => this.snSkuSelectorLoading = false);
        }
        this.showSnSkuSelector = !this.showSnSkuSelector;
      },
      handleCLickChannelSelect() {
        if (this.purchaseChannelList == null) getPurchaseChannelList();
      },
      handleInputPhoneNumber(e) {
        const value = e.target.value?.replace(/\D/g, '');
        this.registerForm.phone = value;
        this.showIllegalPhoneNumber = false;
      },
      checkPhoneNumber(value) {
        return /^\d{7,11}$/.test(value);
      },
      handleChangePhoneNumber(e) {
        const value = e.target.value;
        if (value == '') {
          this.showIllegalPhoneNumber = false;
        } else {
          const isValid = this.checkPhoneNumber(value);
          this.showIllegalPhoneNumber = !isValid;
        }
      },
      // 聚焦日期选择
      focusPurchaseDate(e) {
        const target = e.target;
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const formattedDate = `${yyyy}-${mm}-${dd}`;
        target.setAttribute('max', formattedDate);
      },
      handleCancelAddProduct() {
        if (this.backToWarranty) {
          // 返回质保卡页
          window.location.href = `${window.theme.routes.root_url}pages/account-warranty`;
          // window.history.length > 1
          //   ? window.history.back() :
          //   window.location.href = `${window.theme.routes.root_url}pages/account-warranty`;
        } else {
          this.route = this.routes.default;
          this.scrollToContainer();
        }
      },
      handleConfirmAddProduct() {
        const validity = this.$refs.registerformElement.reportValidity();
        if (!validity || this.confirmLoading) return;
        if (this.registerForm.phone != null && this.registerForm.phone != '' && !this.checkPhoneNumber(this.registerForm.phone)) {
          this.showIllegalPhoneNumber = true;
          return;
        }
        // 未配网的设备，必须有Product id
        if (!this.isConfiguredProductForm && (this.selectSnProduct == null || this.selectSnProduct == '')) return;
        this.confirmLoading = true;
        const registerForm = this.registerForm;
        // 传数据
        let data = {
          email: registerForm.email,
          order_number: registerForm.order_number,
          purchase_channel_id: registerForm.purchase_channel_id != null ? Number(registerForm.purchase_channel_id) : null,
          purchase_channel: this.purchaseChannelList.find(v => v.id == registerForm.purchase_channel_id)?.name,
          purchase_date: registerForm.purchase_date ? Math.floor(new Date(registerForm.purchase_date).getTime() / 1000) : null,
          shopfiy_user_id: registerForm.shopfiy_user_id?.toString(),
          sn: registerForm.sn?.toUpperCase(),
          country_code: registerForm.country_code,
          product_id: registerForm.product_id,
        };
        // 手机号码
        if (!!registerForm.phone && !!registerForm.phone_country_code) {
          data = { ...data, ...{ phone: registerForm.phone, phone_country_code: registerForm.phone_country_code, } };
        }
        // 去除空值
        const cleanedData = Object.entries(data).reduce((acc, [key, value]) => {
          if (value != null) {
            acc[key] = value;
          }
          return acc;
        }, {});
        request(api.productRegister, cleanedData).then((res) => {
          if (res.success || res.success == "true") {
            this.route = this.routes.registerProductSuccess;
            this.formErrorCode = null;
          } else {
            this.formErrorCode = res.code;
            this.route = this.routes.registerProductFailed;
          }
          // 注册成功后刷新列表
          this.getRegisteredproducts();
          this.getUnregisteredproducts();
        }).catch((err) => {
          this.route = this.routes.registerProductFailed;
          console.error(err);
        }).finally(() => {
          this.confirmLoading = false;
          if (window.innerWidth < 589) {
            setTimeout(() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 200);
          }
        });
      },
      // 注册成功，返回
      handleSuccessReturn() {
        // 特殊情况下返回质保卡页
        if (this.backToWarranty) {
          window.location.href = `${window.theme.routes.root_url}pages/account-warranty`;
          // window.history.length > 1
          //   ? window.history.back() :
          //   window.location.href = `${window.theme.routes.root_url}pages/account-warranty`;
        } else {
          this.route = this.routes.default;
        }
      },
      // 移动端未注册产品遮挡页脚
      resizeFooter() {
        const footerContent = document.querySelector('.site-footer>*:last-child');
        const aside = document.querySelector('.product-registration__aside');
        if (footerContent && aside) {
          footerContent.style.setProperty('--margin-bottom', aside.clientHeight + 'px');
        } else {
          footerContent.style.setProperty('--margin-bottom', 0 + 'px');
        }
      }
    }
  });
})();
